'use client';

import { type FC } from 'react';
import { Button } from '../../ui';
import { ScreenContent, ScreenFixedBottom } from '../../../screen';
import { ResultBoard } from './ResultBoard';
import { useReplayShare } from '../../../hooks/useReplayShare';
import { useLocalTranslation } from '../../../hooks/useLocalTranslation';
import translations from './RushMid.translations';
import type { Payout } from './economy';
import type { ScoreEntry } from './useRushMidMatch';

export interface ResultScreenProps {
  payout: Payout;
  scoreboard?: ScoreEntry[];
  youFighterId?: string | null;
  /** match id — shown with a copy button on the board */
  matchId?: string;
  onAgain: () => void;
  /** "again" is resolving (leave + reformed-party fetch) — spin the button, ignore re-taps */
  againBusy?: boolean;
  /** optional — open the match log */
  onViewLog?: () => void;
  /** play the case-open reveal sequence — live result only, not history re-opens. */
  celebrateDrops?: boolean;
}

export const ResultScreen: FC<ResultScreenProps> = ({ payout, scoreboard, youFighterId, matchId, onAgain, againBusy = false, onViewLog, celebrateDrops }) => {
  const { t } = useLocalTranslation(translations);
  const share = useReplayShare(matchId ?? '', t('replayShareText'), t('replayShareButton'));

  return (
    <>
    <ScreenContent hideLegalSection scrollKey="rush-mid-result">
      <ResultBoard payout={payout} scoreboard={scoreboard} youFighterId={youFighterId} matchId={matchId} onShare={share.share} sharing={share.isSharing} celebrateDrops={celebrateDrops} />
    </ScreenContent>
    <ScreenFixedBottom className="flex flex-col gap-2 px-4 pb-[max(16px,var(--tg-viewport-safe-area-inset-bottom,0px))]">
      <Button variant="primary" size="l" stretched loading={againBusy} disabled={againBusy} onClick={onAgain}>
        {t('again')}
      </Button>
      {onViewLog && (
        <Button variant="tertiary" size="l" stretched onClick={onViewLog}>
          {t('viewLog')}
        </Button>
      )}
    </ScreenFixedBottom>
    </>
  );
};
